<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M199.997 366.669C292.044 366.669 366.663 292.05 366.663 200.003C366.663 107.955 292.044 33.3359 199.997 33.3359C107.949 33.3359 33.3301 107.955 33.3301 200.003C33.3301 292.05 107.949 366.669 199.997 366.669Z"
    stroke="var(--stroke-color)"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M245.365 137.769C253.508 135.055 257.579 133.697 260.286 134.663C262.642 135.503 264.496 137.357 265.336 139.713C266.302 142.42 264.945 146.492 262.231 154.634L237.438 229.011C236.665 231.33 236.279 232.49 235.62 233.453C235.037 234.306 234.3 235.043 233.447 235.626C232.484 236.285 231.325 236.671 229.006 237.444L154.628 262.237C146.486 264.951 142.415 266.308 139.707 265.342C137.351 264.502 135.497 262.648 134.657 260.292C133.692 257.585 135.049 253.514 137.763 245.371L162.555 170.994C163.328 168.675 163.715 167.515 164.373 166.552C164.957 165.7 165.694 164.963 166.547 164.379C167.509 163.721 168.669 163.334 170.988 162.561L245.365 137.769Z"
    stroke="var(--stroke-color)"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
